import { Container } from './CustomStatus.styles';

const CustomStatusError = () => {
  return <Container>error on load custom status</Container>;
};

export { CustomStatusError };
